import Crud from '../components/ManualCheck/Crud'
import Add from '../components/ManualCheck/Add'

let routes = {
    path: '/manualChecks',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/manualChecks',
            name: 'Pontos Manuais',
            component: Crud
        },
        {
            path: '/manualCheck/:id?',
            name: 'Ponto Manual',
            component: Add
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/manualCheck.js